import React from 'react'
import About from '../../components/about.js';

export default () => <About/>